export function signed(value) {
  return (value > 0 ? '+' : '') + value;
}
